<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <base-input label="Site Selection" class="col-md-6">
                            <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedSiteId" @change="updateTerminalList" :disabled="site_type != 'ho'">
                                <a-select-option v-for="site in validSites" :key="site.id" :value="site.id">{{site.name}}</a-select-option>
                            </a-select>
                        </base-input>
                        <!-- <base-input label="From" class="col-md-6">
                            <br><a-date-picker @change="onDateFilter2" :format="dateFormat" input-classes="form-control" style="width: 100%"/>
                        </base-input>  -->
                         <base-input label="Date Range" class="col-md-6">
                            <br><a-range-picker @change="onDateFilter2" :format="dateFormat" :allowClear="false" input-classes="form-control" style="width: 100%"/>
                        </base-input>

                        <base-input label="Terminal" class="col-md-6">
                            <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedTerminalId">
                                <a-select-option v-for="terminal in validTerminals" :key="terminal.id" :value="terminal.id">{{terminal.name}} ({{terminal.code}})</a-select-option>
                            </a-select>
                        </base-input>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <download-excel
                                worksheet="BIR Sales Reports"
                                name="bir_sales_reports.xls"
                                type="xls"
                                :fetch="excelData"
                                :fields="json_fields">
                                <button class="btn btn-sm btn-success float-right ml-2"
                                        style="border-radius: 24px; border:0px; width: 20%;">
                                    Generate Report in Excel
                                </button>
                            </download-excel>

                            <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">
                                Generate Report in PDF
                            </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities';

    const fs = require('fs')

    function formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                selectedSiteId: [],
                site_type: "ho",
                selectedTerminalId: [],
                dateFormat: 'YYYY-MM-DD',
                searchDateFrom: null,
                searchDateTo: null,
                validSites: null,
                validTerminals: null,
                dateFilter: null,
                jsonData: [],
                json_fields: {
                    // 'Terminal Number':  'terminaId',
                    'Business Date':  'businessDate' ,
                    'Invoice Number (From)':  'beginningSi' ,
                    'Invoice Number (To)':  'endingSi' ,
                    'Beginning Balance': 'beginningBalance' ,
                    'Ending Balance': 'endingBalance' ,
                    'Gross Sales': 'grossSales' ,
                    'Vatable Sales': 'grossVatableSales' ,
                    'VAT Amount': 'grossVatAmount' ,
                    'VAT Exempt Sales': 'grossVatExemptSales' ,
                    'Zero Rated Sales': 'grossZeroRatedSales' ,
                    'Deductions (Regular Discount)': 'regularDiscount' ,
                    'Deductions (Special Discount 5%)': 'specialDiscount' ,
                    'Deductions (Special Discount 20%)': 'specialExemptDiscount' ,
                    'Deductions (Return)': 'totalReturns' ,
                    'Deductions (Void)': 'totalVoids' ,
                    'Deductions (Manual)': 'totalReplaced' ,
                    'Total Deductions': 'totalDeductions' ,
                    'Adjustments on VAT (Regular)': 'adjustmentOnVatRegular' ,
                    'Adjustments on VAT (Special 5%)': 'adjustmentOnVatSpecial' ,
                    'Adjustments on VAT (Special 20%)': 'adjustmentOnVatSpecialExempt' ,
                    'Adjustments on VAT (Return)': 'adjustmentOnVatReturns' ,
                    'Adjustments on VAT (Void)': 'adjustmentOnVatVoids' ,
                    'Adjustments on VAT (Manual)': 'adjustmentOnVatManual' ,
                    'Total Adjustments': 'totalVatAdjustments' ,
                    'VAT Payables': 'vatPayables' ,
                    'Net Amount Received': 'netAmountReceived' ,
                    'Other Income (Excess GC)': 'excessGC' ,
                    'Other Income (Excess RS)': 'excessRS' ,
                    'Sales Including Excess': 'salesWithExcess' ,
                    'Reset Counter': 'siResetCount' ,
                    'Z-Counter': 'zReadingCounter'
                },
                 imagepath: '',
                 reportDescription: ''
            }
        },
        mounted: async function () {
            var userId = secureStorage.getItem("userId")
            var site_data = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?user_id=' + userId, null)
            this.validSites = site_data
            // var terminal_data = await HTTPRequest.getRequest(this.endPoint + 'terminals/get_valid_terminals', null)
            // this.validTerminals = terminal_data

            let siteId = secureStorage.getItem("defaultSiteId")
            this.selectedSiteId = siteId
            this.updateTerminalList()

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)


            let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
            if (logoSettings.length > 0) {
                let logo_img = logoSettings[0]["value"]
                this.imagepath = this.publicUrl + 'account_logos/' + logo_img
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'publicUrl']),
        },
        methods: {
            moment,
            async updateTerminalList(){
                var terminal_data = await HTTPRequest.getRequest(this.endPoint + 'terminals/get_valid_terminals?site_id=' + this.selectedSiteId, null)
                this.validTerminals = terminal_data
            },
            onDateFilter2(date, dateString) {
                this.searchDateFrom = dateString[0]
                this.searchDateTo = dateString[1]
            },
            formattingExportData(businessDate, detail) {
              // This method is for formatting the data of the ZReading details for excel and PDF
              // Created by Maron Justo

              const { grossSales, netSales, deductions, adjustmentsOnVat, otherIncome } = detail;
              const vatPayables = grossSales.vatAmount - adjustmentsOnVat.total;
              const netAmountReceived = netSales;
              const salesWithExcess = netAmountReceived + otherIncome.total

              return {
                businessDate: moment(businessDate).format("MM-DD-YYYY"),
                beginningSi:  detail.beginningSi,
                endingSi:     detail.endingSi,
                beginningBalance: formatNumber(detail.beginningBalance.toFixed(2)),
                endingBalance:    formatNumber(detail.endingBalance.toFixed(2)),
                grossSales: {
                  total:     formatNumber(grossSales.total.toFixed(2)),
                  vatable:   formatNumber(grossSales.vatable.toFixed(2)),
                  vatAmount: formatNumber(grossSales.vatAmount.toFixed(2)),
                  vatExempt: formatNumber(grossSales.vatExempt.toFixed(2)),
                  zeroRated: formatNumber(grossSales.zeroRated.toFixed(2)),
                },
                deductions: {
                  regular:                  formatNumber(deductions.regular.toFixed(2)),
                  specialVatableDiscount:   formatNumber(deductions.specialVatableDiscount.toFixed(2)),
                  specialVatExemptDiscount: formatNumber(deductions.specialVatExemptDiscount.toFixed(2)),
                  returns:                  formatNumber(deductions.returns.toFixed(2)),
                  void:                     formatNumber(deductions.void.toFixed(2)),
                  manual:                   formatNumber(deductions.manual.toFixed(2)),
                  total:                    formatNumber(deductions.total.toFixed(2)),
                },
                adjustments: {
                  regular:                  formatNumber(adjustmentsOnVat.regular.toFixed(2)),
                  specialVatableDiscount:   formatNumber(adjustmentsOnVat.specialVatableDiscount.toFixed(2)),
                  specialVatExemptDiscount: formatNumber(adjustmentsOnVat.specialVatExemptDiscount.toFixed(2)),
                  returns:                  formatNumber(adjustmentsOnVat.returns.toFixed(2)),
                  void:                     formatNumber(adjustmentsOnVat.void.toFixed(2)),
                  manual:                   formatNumber(adjustmentsOnVat.manual.toFixed(2)),
                  total:                    formatNumber(adjustmentsOnVat.total.toFixed(2)),
                },
                vatPayables:       formatNumber(vatPayables.toFixed(2)),
                netAmountReceived: formatNumber(netAmountReceived.toFixed(2)),
                otherIncome: {
                  excessGC: formatNumber(otherIncome.excessGC.toFixed(2)),
                  excessRS: formatNumber(otherIncome.excessRS.toFixed(2)),
                },
                salesWithExcess: formatNumber(salesWithExcess.toFixed(2)),
                siResetCount:    detail.siResetCount,
                zReadingCounter: detail.zReadingCounter
              }
            },
            totalAllAmount(allTotal, formattedDetails) {
              // Getting all the total of all the amounts of ZReadings

              const { grossSales, netSales, deductions, adjustmentsOnVat, otherIncome } = formattedDetails;
              const vatPayables = grossSales.vatAmount - adjustmentsOnVat.total;
              const netAmountReceived = netSales;
              const salesWithExcess = netAmountReceived + otherIncome.total

              // grossSales
              allTotal.totalSales = (allTotal.totalSales || 0) + grossSales.total;
              allTotal.totalVatablesSales = (allTotal.totalVatablesSales || 0) + parseFloat(grossSales.vatable);
              allTotal.totalVatAmount = (allTotal.totalVatAmount || 0) + parseFloat(grossSales.vatAmount);
              allTotal.totalVatExemptSales = (allTotal.totalVatExemptSales || 0) + parseFloat(grossSales.vatExempt);
              allTotal.totalZeroRatedSales = (allTotal.totalZeroRatedSales || 0) + parseFloat(grossSales.zeroRated);

              // deductions
              allTotal.totalRegularDeductions = (allTotal.totalRegularDeductions || 0) + parseFloat(deductions.regular);
              allTotal.totalSpecialDeductions = (allTotal.totalSpecialDeductions || 0) + parseFloat(deductions.specialVatableDiscount);
              allTotal.totalSpecialDeductions2 = (allTotal.totalSpecialDeductions2 || 0) + parseFloat(deductions.specialVatExemptDiscount);
              allTotal.totalReturnDeductions = (allTotal.totalReturnDeductions || 0) + parseFloat(deductions.returns);
              allTotal.totalVoidDeductions = (allTotal.totalVoidDeductions || 0) + parseFloat(deductions.void);
              allTotal.totalManualDeductions = (allTotal.totalManualDeductions || 0) + parseFloat(deductions.manual);
              allTotal.totalDeductions2 = (allTotal.totalDeductions2 || 0) + parseFloat(deductions.total);

              // adjustments
              allTotal.totalVatAdjustmentRegular = (allTotal.totalVatAdjustmentRegular || 0) + parseFloat(adjustmentsOnVat.regular);
              allTotal.totalVatAdjustmentSpecial = (allTotal.totalVatAdjustmentSpecial || 0) + parseFloat(adjustmentsOnVat.specialVatableDiscount);
              allTotal.totalVatAdjustmentSpecial2 = (allTotal.totalVatAdjustmentSpecial2 || 0) + parseFloat(adjustmentsOnVat.specialVatExemptDiscount);
              allTotal.totalVatAdjustmentReturn = (allTotal.totalVatAdjustmentReturn || 0) + parseFloat(adjustmentsOnVat.returns);
              allTotal.totalVatAdjustmentVoid = (allTotal.totalVatAdjustmentVoid || 0) + parseFloat(adjustmentsOnVat.void);
              allTotal.totalVatAdjustmentManual = (allTotal.totalVatAdjustmentManual || 0) + parseFloat(adjustmentsOnVat.manual);
              allTotal.totalAdjustment2 = (allTotal.totalAdjustment2 || 0) + parseFloat(adjustmentsOnVat.total);

              // Vat Payables & Net Amount Received
              allTotal.totalVatPayables = (allTotal.totalVatPayables || 0) + parseFloat(vatPayables);
              allTotal.totalNetAmountReceived = (allTotal.totalNetAmountReceived || 0) + parseFloat(netAmountReceived);

              // Other Income
              allTotal.totalExcessGC = (allTotal.totalExcessGC || 0) + parseFloat(otherIncome.excessGC);
              allTotal.totalExcessRS = (allTotal.totalExcessRS || 0) + parseFloat(otherIncome.excessRS);
              allTotal.totalSalesIncludingExcess = (allTotal.totalSalesIncludingExcess || 0) + parseFloat(salesWithExcess);
            },
            async excelData() {
              this.spinning= true;

              if(this.searchDateFrom == null || this.searchDateTo == null || this.selectedTerminalId == ''){
                    this.$notification['error']({
                        message: 'Export Error',
                        description: 'Please make sure to check your current filters.'
                    });
                    this.spinning= false;
                    return
                }

              this.jsonData = [];
              const url = `${this.endPoint}z_readings/bir_sales_report?from=${this.searchDateFrom}&to=${this.searchDateTo}&terminal_id=${this.selectedTerminalId}`
              const queryResult = await HTTPRequest.getRequest(url, null)

              if (queryResult.report_details[0].report_details.length == 0) {
                    this.$notification['warning']({
                    message: 'Export Error',
                    description: 'Empty data. Try increasing the scope by adjusting the filters.'
                    });
                    this.spinning= false;
                    return [];
                }
              const terminalZReadings = queryResult.report_details || []

              terminalZReadings.map(terminalZReading => {
                const zReadings = terminalZReading.report_details;
                const allTotal = {}

                zReadings.map(zReading => {
                  const zReadingDetails = JSON.parse(zReading.reading_details);

                  this.totalAllAmount(allTotal, zReadingDetails);

                  const formattedDetails = this.formattingExportData(zReading.business_date, zReadingDetails);
                  const { grossSales, deductions, adjustments, otherIncome } = formattedDetails;

                  this.jsonData.push({
                    businessDate: formattedDetails.businessDate,
                    beginningSi: formattedDetails.beginningSi,
                    endingSi: formattedDetails.endingSi,

                    // Balances
                    beginningBalance: formattedDetails.beginningBalance,
                    endingBalance: formattedDetails.endingBalance,

                    // Gross Sales
                    grossSales: grossSales.total,
                    grossVatableSales: grossSales.vatable,
                    grossVatAmount: grossSales.vatAmount,
                    grossVatExemptSales: grossSales.vatExempt,
                    grossZeroRatedSales: grossSales.zeroRated,

                    // Deductions
                    regularDiscount: deductions.regular,
                    specialDiscount: deductions.specialVatableDiscount,
                    specialExemptDiscount: deductions.specialVatExemptDiscount,
                    totalReturns: deductions.returns,
                    totalVoids: deductions.void,
                    totalReplaced: deductions.manual,
                    totalDeductions: deductions.total,

                    // AdjustmentsOnVat
                    adjustmentOnVatRegular: adjustments.regular,
                    adjustmentOnVatSpecial: adjustments.specialVatableDiscount,
                    adjustmentOnVatSpecialExempt: adjustments.specialVatExemptDiscount,
                    adjustmentOnVatReturns: adjustments.returns,
                    adjustmentOnVatVoids: adjustments.void,
                    adjustmentOnVatManual: adjustments.manual,
                    totalVatAdjustments: adjustments.total,

                    // Vat Payables & Net Amount Received
                    vatPayables: formattedDetails.vatPayables,
                    netAmountReceived: formattedDetails.netAmountReceived,

                    // Other Income
                    excessGC: otherIncome.excessGC,
                    excessRS: otherIncome.excessRS,

                    // Other data
                    salesWithExcess: formattedDetails.salesWithExcess,
                    siResetCount: formattedDetails.siResetCount,
                    zReadingCounter: formattedDetails.zReadingCounter,
                  })
                }) // zReadings map loop

                for (const key in allTotal) { allTotal[key] = formatNumber((parseFloat(allTotal[key]) || 0.00).toFixed(2)); }

                // Input total values
                this.jsonData.push({
                  businessDate: "TOTAL:",
                  beginningSi: '',
                  endingSi: '',

                  // Balances
                  beginningBalance: '',
                  endingBalance: '',

                  // Gross Sales
                  grossSales: allTotal.totalSales,
                  grossVatableSales: allTotal.totalVatablesSales,
                  grossVatAmount: allTotal.totalVatAmount,
                  grossVatExemptSales: allTotal.totalVatExemptSales,
                  grossZeroRatedSales: allTotal.totalZeroRatedSales,

                  // Deductions
                  regularDiscount: allTotal.totalRegularDeductions,
                  specialDiscount: allTotal.totalSpecialDeductions,
                  specialExemptDiscount: allTotal.totalSpecialDeductions2,
                  totalReturns: allTotal.totalReturnDeductions,
                  totalVoids: allTotal.totalVoidDeductions,
                  totalReplaced: allTotal.totalManualDeductions,
                  totalDeductions: allTotal.totalDeductions2,

                  // AdjustmentsOnVat
                  adjustmentOnVatRegular: allTotal.totalVatAdjustmentRegular,
                  adjustmentOnVatSpecial: allTotal.totalVatAdjustmentSpecial,
                  adjustmentOnVatSpecialExempt: allTotal.totalVatAdjustmentSpecial2,
                  adjustmentOnVatReturns: allTotal.totalVatAdjustmentReturn,
                  adjustmentOnVatVoids: allTotal.totalVatAdjustmentVoid,
                  adjustmentOnVatManual: allTotal.totalVatAdjustmentManual,
                  totalVatAdjustments: allTotal.totalAdjustment2,

                  // Vat Payables & Net Amount Received
                  vatPayables: allTotal.totalVatPayables,
                  netAmountReceived: allTotal.totalNetAmountReceived,

                  // Other Income
                  excessGC: allTotal.totalExcessGC,
                  excessRS: allTotal.totalExcessRS,

                  // Other data
                  salesWithExcess: allTotal.totalSalesIncludingExcess,
                  siResetCount: '',
                  zReadingCounter: '',
                })
              }) // terminalZReadings map loop
              this.spinning= false;
              return this.jsonData;
            },
            async generateReport(){
                this.spinning= true;
               
                if(this.searchDateFrom == null || this.searchDateTo == null || this.selectedTerminalId == ''){
                    this.$notification['error']({
                        message: 'Export Error',
                        description: 'Please make sure to check your current filters.'
                    });
                    this.spinning= false;
                    return
                }

                var queryResult = await HTTPRequest.getRequest(this.endPoint + 'z_readings/bir_sales_report?from=' + this.searchDateFrom +  "&to=" + this.searchDateTo + "&terminal_id=" + this.selectedTerminalId , null)

                if (queryResult.report_details[0].report_details.length == 0) {
                    this.$notification['warning']({
                    message: 'Export Error',
                    description: 'Empty data. Try increasing the scope by adjusting the filters.'
                    });
                    this.spinning= false;
                    return [];
                }
                var siteSpecific = queryResult.report_details

                var headers = [
                    [
                        {content: 'Business Date', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Invoice Number', rowSpan: 2, colSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Beginning Balance', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Ending Balance', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Gross Sales', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Vatable Sales', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'VAT Amount', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Vat-Exempt Sales', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Zero Rated Sales', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Deductions', colSpan: 7, styles: {halign: 'center'}},
                        {content: 'Adjustments on VAT', colSpan: 7, styles: {halign: 'center'}},
                        {content: 'VAT Payables', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Net Amount Received', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Other Income', rowSpan: 2, colSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Sales Including Excess', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Reset Counter', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Z-Counter', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                    ],
                    [
                        {content: 'Discounts', colSpan: 3, styles: {halign: 'center'}},
                        {content: 'Return', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Void', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Manual', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Total Deductions', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Regular', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Special (5%)', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Special (20%)', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Return', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Void', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Manual', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Total Adjustments', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}
                    ],
                    ["From", "To", "Regular", "Special (5%)", "Special (20%)", "Excess GC", "Excess RS"]
                ];
                var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: [615, 1670] });

                let reportLogo = document.getElementById('reportLogo');
                doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                var siteTotalSales = 0, siteTotalVatablesSales = 0, siteTotalVatAmount = 0, siteTotalVatExemptSales = 0,
                    siteTotalZeroRatedSales = 0, siteTotalRegularDeductions = 0, siteTotalSpecialDeductions = 0, siteTotalReturnDeductions = 0,
                    siteTotalVoidDeductions = 0, siteTotalManualDeductions = 0, siteTotalDeductions2 = 0, siteTotalVatAdjustmentRegular = 0,
                    siteTotalVatAdjustmentSpecial = 0, siteTotalVatAdjustmentReturn = 0, siteTotalVatAdjustmentVoid = 0, siteTotalVatAdjustmentManual = 0,
                    siteTotalAdjustment2 = 0, siteTotalVatPayables = 0, siteTotalNetAmountReceived = 0, siteTotalExcessGC = 0, siteTotalExcessRS = 0,siteTotalSalesIncludingExcess = 0, siteTotalVatAdjustmentSpecial2 = 0, siteTotalSpecialDeductions2 = 0;

                for(var x=0; x < siteSpecific.length; x++){
                    this.birCombinedReports = siteSpecific[x].report_details

                    console.log("Site specific")
                    console.log(siteSpecific[x])

                    if(x > 0 ){
                        doc.addPage();
                    }

                    var reportData = [];

                    // Old Summation of cost code
                    // Commented by Maron Justo
                    // var totalSales = 0, totalVatablesSales = 0, totalVatAmount = 0, totalVatExemptSales = 0, totalZeroRatedSales = 0,
                    //     totalRegularDeductions = 0, totalSpecialDeductions = 0, totalSpecialDeductions2 = 0,
                    //     totalReturnDeductions = 0, totalVoidDeductions = 0, totalManualDeductions = 0, totalDeductions2 = 0, totalVatAdjustmentRegular = 0,
                    //     totalVatAdjustmentSpecial = 0,totalVatAdjustmentSpecial2 = 0, totalVatAdjustmentReturn = 0, totalVatAdjustmentVoid = 0,
                    //     totalVatAdjustmentManual = 0, totalAdjustment2 = 0, totalVatPayables = 0, totalNetAmountReceived = 0, totalExcessGC = 0,
                    //     totalExcessRS = 0, totalSalesIncludingExcess = 0;

                    let allTotal = {};

                    for(var i=0; i < this.birCombinedReports.length; i++){
                        var reportLine = this.birCombinedReports[i]
                        var reportLineDetails = JSON.parse(reportLine.reading_details)

                        this.totalAllAmount(allTotal, reportLineDetails);

                        const formattedDetails = this.formattingExportData(reportLine.business_date, reportLineDetails);
                        const { grossSales, deductions, adjustments, otherIncome } = formattedDetails;

                        // Old Summation of cost code
                        // Commented by Maron Justo
                        // // grossSales
                        // totalSales += parseFloat(grossSales.total);
                        // totalVatablesSales += parseFloat(grossSales.vatable);
                        // totalVatAmount += parseFloat(grossSales.vatAmount);
                        // totalVatExemptSales += parseFloat(grossSales.vatExempt);
                        // totalZeroRatedSales += parseFloat(grossSales.zeroRated);

                        // // deductions
                        // totalRegularDeductions += parseFloat(deductions.regular);
                        // totalSpecialDeductions += parseFloat(deductions.specialVatableDiscount);
                        // totalSpecialDeductions2 += parseFloat(deductions.specialVatExemptDiscount);
                        // totalReturnDeductions += parseFloat(deductions.returns);
                        // totalVoidDeductions += parseFloat(deductions.void);
                        // totalManualDeductions += parseFloat(deductions.manual);
                        // totalDeductions2 += parseFloat(deductions.total);

                        // // adjustments
                        // totalVatAdjustmentRegular += parseFloat(adjustments.regular);
                        // totalVatAdjustmentSpecial += parseFloat(adjustments.specialVatableDiscount);
                        // totalVatAdjustmentSpecial2 += parseFloat(adjustments.specialVatExemptDiscount);
                        // totalVatAdjustmentReturn += parseFloat(adjustments.returns);
                        // totalVatAdjustmentVoid += parseFloat(adjustments.void);
                        // totalVatAdjustmentManual += parseFloat(adjustments.manual);
                        // totalAdjustment2 += parseFloat(adjustments.total);
                        // totalVatPayables += parseFloat(formattedDetails.vatPayables);
                        // totalNetAmountReceived += parseFloat(formattedDetails.netAmountReceived);

                        // // otherIncome
                        // totalExcessGC += parseFloat(otherIncome.excessGC);
                        // totalExcessRS += parseFloat(otherIncome.excessRS);
                        // totalSalesIncludingExcess += parseFloat(formattedDetails.salesWithExcess);

                        const detail = [
                          formattedDetails.businessDate,
                          formattedDetails.beginningSi,
                          formattedDetails.endingSi,

                          // Balances
                          formattedDetails.beginningBalance,
                          formattedDetails.endingBalance,

                          // grossSales
                          grossSales.total,
                          grossSales.vatable,
                          grossSales.vatAmount,
                          grossSales.vatExempt,
                          grossSales.zeroRated,

                          // deductions
                          deductions.regular,
                          deductions.specialVatableDiscount,
                          deductions.specialVatExemptDiscount,
                          deductions.returns,
                          deductions.void,
                          deductions.manual,
                          deductions.total,

                          // adjustmentsOnVat
                          adjustments.regular,
                          adjustments.specialVatableDiscount,
                          adjustments.specialVatExemptDiscount,
                          adjustments.returns,
                          adjustments.void,
                          adjustments.manual,
                          adjustments.total,

                          // !!!! Unknown
                          formattedDetails.vatPayables,
                          formattedDetails.netAmountReceived,

                          // otherIncome
                          otherIncome.excessGC,
                          otherIncome.excessRS,

                          formattedDetails.salesWithExcess,
                          formattedDetails.siResetCount,
                          formattedDetails.zReadingCounter
                        ]

                        reportData.push(Object.assign({}, detail))
                    }

                    // Old Summation of cost code
                    // Commented by Maron Justo
                    // siteTotalSales += totalSales
                    // siteTotalVatablesSales += totalVatablesSales
                    // siteTotalVatAmount += totalVatAmount
                    // siteTotalVatExemptSales += totalVatExemptSales
                    // siteTotalZeroRatedSales += totalZeroRatedSales
                    // siteTotalRegularDeductions += totalRegularDeductions
                    // siteTotalSpecialDeductions += totalSpecialDeductions
                    // siteTotalSpecialDeductions2 += totalSpecialDeductions2
                    // siteTotalReturnDeductions += totalReturnDeductions
                    // siteTotalVoidDeductions += totalVoidDeductions
                    // siteTotalManualDeductions += totalManualDeductions
                    // siteTotalDeductions2 += totalDeductions2
                    // siteTotalVatAdjustmentRegular += totalVatAdjustmentRegular
                    // siteTotalVatAdjustmentSpecial += totalVatAdjustmentSpecial
                    // siteTotalVatAdjustmentSpecial2 += totalVatAdjustmentSpecial2
                    // siteTotalVatAdjustmentReturn += totalVatAdjustmentReturn
                    // siteTotalVatAdjustmentVoid += totalVatAdjustmentVoid
                    // siteTotalVatAdjustmentManual += totalVatAdjustmentManual
                    // siteTotalAdjustment2 += totalAdjustment2
                    // siteTotalVatPayables += totalVatPayables
                    // siteTotalNetAmountReceived += totalNetAmountReceived
                    // siteTotalExcessGC += totalExcessGC
                    // siteTotalExcessRS += totalExcessRS
                    // siteTotalSalesIncludingExcess+= totalSalesIncludingExcess

                    // if(x == (siteSpecific.length - 1)){
                    //     reportData.push(Object.assign({}, [
                    //         "TOTAL: ", "", "", "", "", formatNumber(siteTotalSales.toFixed(2)), formatNumber(siteTotalVatablesSales.toFixed(2)), formatNumber(siteTotalVatAmount.toFixed(2)), formatNumber(siteTotalVatExemptSales.toFixed(2)), formatNumber(siteTotalZeroRatedSales.toFixed(2)), formatNumber(siteTotalRegularDeductions.toFixed(2)), formatNumber(siteTotalSpecialDeductions.toFixed(2)), formatNumber(siteTotalSpecialDeductions2.toFixed(2)), formatNumber(siteTotalReturnDeductions.toFixed(2)), formatNumber(siteTotalVoidDeductions.toFixed(2)), formatNumber(siteTotalManualDeductions.toFixed(2)), formatNumber(siteTotalDeductions2.toFixed(2)), formatNumber(siteTotalVatAdjustmentRegular.toFixed(2)), formatNumber(siteTotalVatAdjustmentSpecial.toFixed(2)), formatNumber(siteTotalVatAdjustmentSpecial2.toFixed(2)), formatNumber(siteTotalVatAdjustmentReturn.toFixed(2)), formatNumber(siteTotalVatAdjustmentVoid.toFixed(2)), formatNumber(siteTotalVatAdjustmentManual.toFixed(2)), formatNumber(siteTotalAdjustment2.toFixed(2)), formatNumber(siteTotalVatPayables.toFixed(2)), formatNumber(siteTotalNetAmountReceived.toFixed(2)), formatNumber(siteTotalExcessGC.toFixed(2)), formatNumber(siteTotalExcessRS.toFixed(2)), formatNumber(siteTotalSalesIncludingExcess.toFixed(2)), "", ""
                    //     ]))
                    // }

                    for (const key in allTotal) { allTotal[key] = formatNumber((parseFloat(allTotal[key]) || 0.00).toFixed(2)); }

                    if(x == (siteSpecific.length - 1)){
                      // Input total values
                      reportData.push(Object.assign({}, [
                        "TOTAL:",
                        '',
                        '',

                        // Balances
                        '',
                        '',

                        // Gross Sales
                        allTotal.totalSales,
                        allTotal.totalVatablesSales,
                        allTotal.totalVatAmount,
                        allTotal.totalVatExemptSales,
                        allTotal.totalZeroRatedSales,

                        // Deductions
                        allTotal.totalRegularDeductions,
                        allTotal.totalSpecialDeductions,
                        allTotal.totalSpecialDeductions2,
                        allTotal.totalReturnDeductions,
                        allTotal.totalVoidDeductions,
                        allTotal.totalManualDeductions,
                        allTotal.totalDeductions2,

                        // AdjustmentsOnVat
                        allTotal.totalVatAdjustmentRegular,
                        allTotal.totalVatAdjustmentSpecial,
                        allTotal.totalVatAdjustmentSpecial2,
                        allTotal.totalVatAdjustmentReturn,
                        allTotal.totalVatAdjustmentVoid,
                        allTotal.totalVatAdjustmentManual,
                        allTotal.totalAdjustment2,

                        // Vat Payables & Net Amount Received
                        allTotal.totalVatPayables,
                        allTotal.totalNetAmountReceived,

                        // Other Income
                        allTotal.totalExcessGC,
                        allTotal.totalExcessRS,

                        // Other data
                        allTotal.totalSalesIncludingExcess,
                        '',
                        '',
                      ]));
                    }


                    doc.setFontSize(14);
                    doc.setFontType("bold");
                    doc.text(15,20,"BIR Sales Report")
                    doc.setFontSize(12);
                    doc.text(15,25, siteSpecific[x].site_company || '')
                    doc.text(15,30, siteSpecific[x].site_tin + '-' + siteSpecific[x].site_tin_branch_code || '')
                    doc.text(15,35, siteSpecific[x].site_address || '')



                    doc.setFontType("normal");
                    doc.setFontSize(10);
                    // doc.text(15,30,"Company: " + siteSpecific[x].site_company)
                    // doc.text(15,35,"TIN: " + siteSpecific[x].site_tin)
                    // doc.text(15,45,"Address: " + siteSpecific[x].site_address)
                    doc.text(15,45,"Software: Barter POS Version 5.0")
                    doc.text(15,50,"Serial Number: " + siteSpecific[x].serial_number)
                    doc.text(15,55,"Machine Number: " + siteSpecific[x].machine_number)
                    doc.text(15,60,"POS Terminal Number: " + siteSpecific[x].pos_terminal_number)
                    
                    // doc.text(15,70,"Permit Number:  " + siteSpecific[x].permit_number)

                    if( this.searchDateFrom == this.searchDateTo){
                            doc.text(15,65,"Date: " +  moment(this.searchDateFrom).format(this.dateFormat) )
                    } else {
                        doc.text(15,65,"Date Range: From " + moment(this.searchDateFrom).format(this.dateFormat)  + " to " + moment(this.searchDateTo).format(this.dateFormat))
                    }

                    doc.text(140,45,"Branch Code: " + siteSpecific[x].site_refcode)
                    doc.text(140,50,"Branch Name: " + siteSpecific[x].site_name)

                    doc.text(140,55,"PTUSM Number: " + siteSpecific[x].permit_number)
                    doc.text(140,60,"Accreditation Number: " + siteSpecific[x].acrreditation_number)
                    doc.text(140,65,"Cashier ID: " + siteSpecific[x].user_name)

                    // doc.setFontSize(14);
                    // doc.setFontType("bold");
                    // doc.text(15,20,"BIR Sales Report")
                    // doc.setFontType("normal");
                    // doc.setFontSize(10);
                    // doc.text(15,25,"Company: " + siteSpecific[x].site_company)
                    // doc.text(15,30,"TIN: " + siteSpecific[x].site_tin)
                    // doc.text(15,35,"Branch: " + siteSpecific[x].site_name)
                    // if( this.searchDateFrom == this.searchDateTo){
                    //     doc.text(15,40,"Date: " +  moment(this.searchDateFrom).format(this.dateFormat) )
                    // } else {
                    //     doc.text(15,40,"Date Range: From " + moment(this.searchDateFrom).format(this.dateFormat)  + " to " + moment(this.searchDateTo).format(this.dateFormat))
                    // }

                    // doc.text(130,25,"POS Terminal Number: " + siteSpecific[x].pos_terminal_number)
                    // doc.text(130,30,"Machine Number: " + siteSpecific[x].machine_number)
                    // doc.text(130,35,"Serial Number: " + siteSpecific[x].serial_number)
                    // doc.text(130,40,"Permit Number:  " + siteSpecific[x].permit_number)

                    doc.autoTable(
                        {
                            startY: 80,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            styles: {
                                cellPadding: 0.5, fontSize: 7,
                                lineWidth: 0.05,
                                halign: 'right'
                            },
                            headStyles: {
                                lineWidth: 0.05,
                                cellPadding: 2
                            },
                            columnStyles: {
                                0: {halign: "center"},
                                1: {halign: "center"},
                                2: {halign: "center"},
                                3: {halign: "center"},
                                28: {halign: "center"},
                                29: {halign: "center"},
                            }
                        }
                    );

                    doc.setFontSize(8);
                    doc.text(15,230,"Printed By: " + secureStorage.getItem("email"))
                    doc.text(550,230,"BIR Sales Report", "right")
                    doc.text(15,235,"Print Date: " + moment().format(this.dateFormat2))
                    doc.text(550,235,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                }
                // doc.output('dataurlnewwindow');
                window.open(URL.createObjectURL(doc.output("blob")))
                this.spinning= false;
            },
        }
    };
</script>

<style></style>
